"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActions = void 0;
const react_1 = __importStar(require("react"));
const Dialog_1 = require("../..");
const DialogActions_styles_1 = require("./DialogActions.styles");
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
const DialogActionButton_1 = require("../DialogActionButton/DialogActionButton");
const isCustomAction_1 = require("./helpers/isCustomAction");
exports.DialogActions = (0, helpers_1.createUIElement)('DialogActions', (_a, ref) => {
    var { className, primary = [], secondary = [], loading, disabled, distribution = Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.end, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "primary", "secondary", "loading", "disabled", "distribution", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const { firstDialogActions, secondDialogActions } = (0, react_1.useMemo)(() => (0, Dialog_1.getDialogActions)({
        distribution,
        primary,
        secondary
    }), [distribution, primary, secondary]);
    const hasSecond = (0, react_1.useMemo)(() => !!firstDialogActions.length && distribution !== Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.center, [distribution, firstDialogActions.length]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'dialog-actions', [initialDataSelectorId]);
    const distributionValue = (0, react_1.useMemo)(() => distribution === Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.center
        ? StackView_1.STACK_DISTRIBUTION.center
        : StackView_1.STACK_DISTRIBUTION.end, [distribution]);
    return (react_1.default.createElement(DialogActions_styles_1.StyledDialogActions, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, distribution: distributionValue, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-DialogActions', className) }),
        firstDialogActions.map((dialogAction, idx) => {
            if ((0, isCustomAction_1.isCustomAction)(dialogAction)) {
                return (react_1.default.createElement(react_1.default.Fragment, { key: dialogAction.id || `first-custom-item-${idx}` }, dialogAction.render()));
            }
            const { id, testId, text, onKeyDown } = dialogAction;
            return (react_1.default.createElement(DialogActionButton_1.DialogActionButton, Object.assign({ key: `${id}-${text}-${idx}` }, dialogAction, { onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                    }
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }, dataSelectorId: testId || `${dataSelectorId}-second-control-${id || idx}`, disabled: disabled || loading || dialogAction.disabled })));
        }),
        hasSecond && react_1.default.createElement("div", { key: "space", style: { flex: '1' } }),
        distribution !== Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.center &&
            secondDialogActions.map((dialogAction, idx) => {
                if ((0, isCustomAction_1.isCustomAction)(dialogAction)) {
                    return (react_1.default.createElement(react_1.default.Fragment, { key: dialogAction.id || `second-custom-item-${idx}` }, dialogAction.render()));
                }
                const { id, text, testId, onKeyDown } = dialogAction;
                return (react_1.default.createElement(DialogActionButton_1.DialogActionButton, Object.assign({ key: `${id}-${text}-${idx}` }, dialogAction, { disabled: disabled || loading || dialogAction.disabled, onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.stopPropagation();
                        }
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    }, dataSelectorId: testId || `${dataSelectorId}-control-${id || idx}` })));
            })));
});
//# sourceMappingURL=DialogActions.js.map